import "../styles/ChatBotPromo.scss";
import { Fade } from "react-awesome-reveal";

const ChatBotPromo = () => {
  return (
    <div className="promo-container">
      <Fade cascade="true" direction="left">
        <h1 className="promo-title">
          ¡Inscríbete hoy y olvídate de la inscripción!
        </h1>
      </Fade>
      <hr />
      <div className="containerBotInfo">
        <Fade>
          <p className="promo-subtitle fw-bold">
            🤖 Chatea con nuestro bot y completa tu registro en minutos
          </p>
        </Fade>

        <Fade>
          <ul className="promo-list">
            <li className="fst-italic">Pide información</li>
            <li className="fst-italic">Resuelve tus dudas</li>
          </ul>
        </Fade>
      </div>

      <Fade>
        <span id="aprovecha" className="fw-bold fs-5">
          "Aprovecha la promoción que tenemos este mes para ti"
        </span>
      </Fade>
      <br />
      <br />
      <hr />
    </div>
  );
};

export default ChatBotPromo;
